import React, { useState } from 'react'
import { Button, Dropdown } from 'semantic-ui-react'
import { categories } from './../../../config/categories'

const Search = ({ save, close }) => {
  const [category, setCategory] = useState('')

  const dropdownchangedHandler = (e, result) => {
    const { value } = result
    setCategory(value)
  }

  const url = "https://z0en1nkupa.execute-api.us-east-1.amazonaws.com/development?rowId="

  const onHandleSave = () => {
    save({
      name: category,
      value: `${url}${category}`
    })
  }

  const onHandleClose = () => {
    close()
  }

  return (
    <>
      <Dropdown
        label={{ icon: 'asterisk' }}
        labelPosition='right corner'
        placeholder=''
        style={{ width: '100%' }}
        onChange={dropdownchangedHandler}
        fluid
        selection
        options={categories} />

      <div
        className="actions"
        style={{ width: '100%', textAlign: 'right', marginTop: '5px' }}>

        <Button onClick={onHandleSave}>
          <i className="search circle right icon"></i> Search
        </Button>

        <Button onClick={onHandleClose}>
          <i className="close icon"></i> Cancel
        </Button>
      </div>

    </>
  )
}

export default Search
